import ModalConfirmPayment from './ModalConfirmPayment';

export default ModalConfirmPayment;
